import { Component, Inject, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { HomeController } from '@shared/src/controllers/home/home.controller';
import { RouteController } from '@shared/src/controllers/route/route.controller';
import { AcquireRouteWizardCtrlDto } from '@shared/src/dtos/route/acquire/AcquireRouteWizardCtrlDto';

@Component({
	selector: 'shared-route-acquire-wizard-resum',
	templateUrl: './shared.route.acquire.wizard.resum.html',
	styleUrls: ['./shared.route.acquire.wizard.resum.scss']
})
export class SharedRouteAcquireWizardResum implements OnInit {

	public useIonic: boolean = false;
	constructor(public routeController: RouteController,
		@Inject('HomeController') protected homeController: HomeController) {

		if (homeController.useIonic)
			this.useIonic = homeController.useIonic();

	}

	ngOnInit(): void {
		
	}

	public _wizard: AcquireRouteWizardCtrlDto;
	@Input()
	public get wizard(): AcquireRouteWizardCtrlDto {
		return this._wizard;
	}
	public set wizard(value: AcquireRouteWizardCtrlDto) {
		if (this._wizard === value)
			return;
		this._wizard = value;
	}

	getRoutes(){
		if(this.wizard != null && this.wizard.routesToAcquire != null && this.wizard.routesToAcquire.length > 0)
			return this.wizard.routesToAcquire;
		return [];
	}

}
